// extracted by mini-css-extract-plugin
export default {"setPrice":"setPrice_setPrice__9GBFJ"};